module.exports = __webpack_public_path__ + "img/制御工学3_1_2.08b16339.png";